import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=d3636d26&scoped=true&"
import script from "./CtaButton.vue?vue&type=script&lang=ts&"
export * from "./CtaButton.vue?vue&type=script&lang=ts&"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=d3636d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3636d26",
  null
  
)

export default component.exports